import type { Flow, FlowMetadata } from '../models/types'

export default function getJs(
  flow: Flow,
  groupId: string,
  metadata: FlowMetadata | {},
  userData: Record<string, unknown>
) {
  if (!metadata) metadata = {}
  const pageTitle = `Embeddables${
    metadata && 'title' in metadata
      ? ': ' + metadata?.title
      : flow.name
      ? ': ' + flow.name
      : flow.title
      ? ': ' + flow.title
      : ''
  }`

  return `
    function (args) {
      let { element } = args || {}
      if (!element) element = document.querySelector('savvy')

      const FLOW_ID = '${flow.id}'
      
      window.SavvyFlow = window.SavvyFlow || {}

      //* Fetch the flow JSON from the renderer backend and store it in the window.SavvyFlow object
      const rendererUrl = \`https://engine.embeddables.com/\${FLOW_ID}\`
      fetch(rendererUrl)
        .then(response => response.json())
        .then(data => {
          window.SavvyFlow[FLOW_ID] = data.flow
        })
        .catch(error => {
          console.error('Error fetching flow JSON:', error)
        })
      
      //* Here we merge all the user data (1° defaults, 2° local storage, 3° user data from backend, minus defaults) and update the local storage
      const allEmbeddablesUserData = JSON.parse(localStorage.getItem('SavvyFormUserData') || '{}')
      const localUserData = ${(!flow.forget_user_data && 'allEmbeddablesUserData[FLOW_ID]') || '{}'}
      const defaultUserData = ${JSON.stringify(flow.defaults?.userData || {})} || {}
      const userDataFromHandleRequestWithoutDefaults = ${JSON.stringify(userData)} || {}
      const fullUserData = { ...defaultUserData, ...localUserData, ...userDataFromHandleRequestWithoutDefaults }
      allEmbeddablesUserData[FLOW_ID] = fullUserData
      ${
        !flow.do_not_store_any_data
          ? 'localStorage.setItem("SavvyFormUserData", JSON.stringify(allEmbeddablesUserData))'
          : ''
      }

      const urlParams = new URLSearchParams(window.location.search)
      const breakpoints = [${[520, 720]
        .concat((flow.breakpoints || []).map((b) => b.max_width))
        .toString()}]
      const entireFlowEl = element.querySelector('.Flow-EntireFlow')
      const currentBreakpointGroups = breakpoints.filter((b) => entireFlowEl.offsetWidth <= b)
      const attrValue = currentBreakpointGroups.map((b) => \`\${b}px\`).join(' ')
      entireFlowEl.setAttribute('max-width', attrValue)

      const editingHostnames = ['edit.embeddables.com']
      const editingUrlRegexes = [
        /^https?:\\/\\/app\\.embeddables\\.com\\/edit\\/.*(\\?.*)?$/,
        /^https?:\\/\\/old\\.embeddables\\.com\\/edit\\/.*(\\?.*)?$/,
        /^https?:\\/\\/radar\\.embeddables\\.com\\/edit\\/.*(\\?.*)?$/,
        /^https?:\\/\\/build\\.embeddables\\.com\\/edit\\/.*(\\?.*)?$/,
        /^https?:\\/\\/embeddables-.+\\.vercel\\.app\\/edit\\/.*(\\?.*)?$/,
      ]

      if (window.location.host.endsWith('trysavvy.com') || window.location.hostname === 'preview.embeddables.com' || window.location.href.includes('app.embeddables.com/edit') || window.location.host.endsWith('cidemo.co') || window.location.host === 'localhost:9000') {
        if(FLOW_ID==='${flow.id}') document.title = '${pageTitle.replaceAll("'", "\\'")}'
      } 

      // Create savvy-global element with data-controller="global"
      if (!document.querySelector('savvy-global')) {
        const savvyGlobal = document.createElement('savvy-global')
        savvyGlobal.setAttribute('data-controller', 'global')
        document.body.appendChild(savvyGlobal)
      }
      
      // Create savvy-editor element with data-controller="global-edit"
      const isEditingMode = (urlParams.get('savvy_editing') || editingHostnames.includes(window.location.hostname) || editingUrlRegexes.some((regex) => regex.test(window.location.href)))
      if (isEditingMode && !document.querySelector('savvy-editor')) {
        // Create savvy-editor element with data-controller="global-edit"
        const savvyEditor = document.createElement('savvy-editor')
        savvyEditor.setAttribute('data-controller', 'global-edit')
        document.body.appendChild(savvyEditor)
      }

      if (!window.Savvy) window.Savvy = {}
      if (!window.Savvy.group_id) window.Savvy.group_id = '${groupId}'
      if (!window.Savvy.project_id) window.Savvy.project_id = ${
        (metadata as FlowMetadata).project_id
          ? `'${(metadata as FlowMetadata).project_id}'`
          : 'null'
      }
      
      if (!window.Savvy.flow_metadata) window.Savvy.flow_metadata = {}
      if (!window.Savvy.flow_metadata['${flow.id}']) window.Savvy.flow_metadata['${
    flow.id
  }'] = ${JSON.stringify({ ...metadata, flow_id: (metadata as FlowMetadata).id })}
  

      // Wrap all the savvy elements in the DOM
      const scriptElements = document.querySelectorAll("script");
      scriptElements?.forEach(script => {
        if (script.textContent.includes("getBundleSrc") && script.previousSibling?.nodeType!==Node.COMMENT_NODE && !script.previousSibling?.textContent?.includes("Embeddables")) {
          const startComment = document.createComment("START: Embeddables (formerly Savvy) Script - https://embeddables.com");
          const endComment = document.createComment("END: Embeddables (formerly Savvy) Script - https://embeddables.com");
          script.parentNode.insertBefore(startComment, script);
          script.parentNode.insertBefore(endComment, script.nextSibling);
        }
      });

      // Get all the <savvy> and <savvy-global> elements in the DOM
      const savvyElements = document.querySelectorAll("savvy, savvy-global");

      if(!isEditingMode) {
        console.log('%cThis page was built using Embeddables', 'font-size: 14px; font-weight:500;font-family: "Consolas", sans-serif; text-shadow: 1px 1px 0px rgba(0,0,0,0.6);text-decoration: none;  background-color: #7144F2; color: #F7F5ED; padding:6px 18px; border-radius: 5px; box-shadow: 10px 10px 0px 3px rgba(0,0,0,0.75);');
        console.log('%c➡  https://embeddables.com', 'font-size: 14px; font-weight:500;font-family: "Consolas", sans-serif; text-decoration: none; padding:6px 0px; border-radius: 5px; box-shadow: 10px 10px 0px 3px rgba(0,0,0,0.75);');
      }

      savvyElements?.forEach(element => {
        if (element.previousSibling?.nodeType===Node.COMMENT_NODE && element.previousSibling?.textContent?.includes("Embeddables")) return;
        const startComment = document.createComment("START: Embeddables (formerly Savvy) Embed Code - https://embeddables.com");
        const endComment = document.createComment("END: Embeddables (formerly Savvy) Embed Code - https://embeddables.com");
        element.parentNode.insertBefore(startComment, element);
        element.parentNode.insertBefore(endComment, element.nextSibling);
      });
    }
  `
}
